import React, { useContext, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import Wrapper from "../Helpers/Wrapper";
import AuthContext from "../store/auth-context";
import Row from "react-bootstrap/Row";
import Login from "../components/Login";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import Placeholder from 'react-bootstrap/Placeholder';



const Events = () => {
  const eventsUrl = "/apps3.php";
  const getRegdUrl = "/regGetRegistrations.php"
  const [eventsObj, setEventsObj] = useState();
  const [showSpinner, setShowSpinner] = useState(true);
  const [dataLoader, setDataLoader] = useState(false);
  const authCtx = useContext(AuthContext);
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const hideSpinner = () => {
    setShowSpinner(false);
  };

  function isInThePast(date, eventName) {
    // console.log(date);
    const today = new Date();
    const theDate = new Date(date.replace(/-/g, '\/'));
    theDate.setHours(23, 59, 59, 0)

    var todayTime = today.getTime();
    // console.log(todayTime);
    var eventTime = theDate.getTime();
    // console.log(eventTime);

    if(eventTime < todayTime) {
        // console.log(`${eventName} in the past: today is ${today} theDate id ${theDate}`);
        return true
      }else if (eventTime > todayTime){
        // console.log(`${eventName} not yet: today is ${today} theDate id ${theDate}`);
        return false
      }else{
        // console.log(`${eventName} not yet: today is ${today} theDate id ${theDate}`);
        return false
      }

  }

  function compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }
  
      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];
  
      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }


  function MyRegistrations (props){
    const [myEvent, setMyEvent] = useState(false);
    
    // useEffect(() => {
      fetch(`${getRegdUrl}?event_id=${props.eventId}`)
      .then(function(response) {
        // The response is a Response instance.
        // You parse the data into a useable format using `.json()`
        // console.log("this is response: ", response);
        
        return response.json();
      }).then(function(data) {
        
        // console.log("this is response: ", data);
        // `data` is the parsed version of the JSON returned from the above endpoint.
        // console.log(data)
        // console.log(typeof data);
        if(data.found === "TRUE"){
          setMyEvent(true);
        }
      });
    // })

    if(myEvent){
      // console.log('returning true');
      return (
        <div className="text-center">
          <br></br><a href={`https://msmta.org/registration/regPrintConfirm.php?event_id=${props.eventId}`} target="_blank">Print your registrations for this event</a>
        </div>
      );
    }else {
      // console.log('returning false');
      return undefined;
    }

  }

  useEffect(() => {
    const dataFetch = async () => {
      // console.log(await fetch(eventsUrl));
      const data = await (await fetch(eventsUrl)).json();
      // console.log(`This is the data before json: ${JSON.stringify(data)}`);

      const dateData = data.map(obj => {
        return {...obj, event_date: new Date(obj.event_date)}
      })

      const sortedAsc = dateData.sort(
        (objA, objB) => objA.full_name.localeCompare(objB.full_name) || Number(objA.event_date) - Number(objB.event_date),
        // (objA, objB) => objA.full_name < objB.full_name || objA.event_date.toDateString().localCompare(objB.event_date.toDateString()),
      );

      // console.log(`This is the data after sorting: ${JSON.stringify(sortedAsc)}`);


      setEventsObj(sortedAsc);
      // setEventsObj(data.sort(compareValues('full_name')));
      setDataLoader(true);
      // console.log(`This is the event data: ${JSON.stringify(data)}`);
    };
    dataFetch();
    hideSpinner();
  },[]);

  function nthNumber(number){
    if (number > 3 && number < 21) return `${number}th`;
    switch (number % 10) {
      case 1:
        return `${number}st`;
      case 2:
        return `${number}nd`;
      case 3:
        return `${number}rd`;
      default:
        return `${number}th`;
    }
  };

  function eventDate(eventDate){
    let date = new Date(eventDate);
    let currEventDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    let eventWeekDay = days[currEventDate.getDay()];
    let eventMonth = monthNames[currEventDate.getMonth()];
    let eventYear = currEventDate.getFullYear();
    let eventDayofMonth = currEventDate.getDate();
    return `${eventWeekDay}, ${eventMonth} ${nthNumber(eventDayofMonth)}, ${eventYear}`;
    // return new Date(date.getTime() + date.getTimezoneOffset() * 60000).toDateString()
  }



  return (
    <Container>
        <Wrapper>
        <Container className="py-2 mb-3">
        {showSpinner ? (
          <div>
            <Card.Title>Please wait, loading...</Card.Title>
            <Placeholder as={Card.Text} animation="glow">
              <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} />{' '}
              <Placeholder xs={6} /> <Placeholder xs={8} />
            </Placeholder>
          </div>
        ) : null}
        <Row>
          {!dataLoader ? showSpinner : 
          (!eventsObj ? 
          <div className="text-center">
            <h2>Currently there are no events open for registration.</h2>
          </div>
          : undefined)
          }
        <Accordion defaultActiveKey={["0", "1"]}>
          {eventsObj?.map((event) => (
            // !isInThePast(event.reg_close_date, event.full_name) ? 
            <Accordion.Item eventKey={event.event_id}>
            <Accordion.Header>
              {/* <strong>{event.full_name} on {new Date(event.event_date.replace(/-/g, '/')).toDateString()}</strong> */}
              {/* <strong>{event.full_name} on {new Date(event.event_date + date.getTimezoneOffset() * 60000).toDateString()}</strong> */}
              <strong>{event.full_name} on {eventDate(event.event_date)}</strong>
            </Accordion.Header>
            <Accordion.Body>
              <Table responsive="lg">
                <tbody>
                  <tr>
                    <div className="text-center">Registration deadline: {new Date(event.reg_close_date.replace(/-/g, '/')).toDateString()}</div>
                    <div className="text-center"></div>
                  </tr>
                  <tr>
                  {event.isOnline ? (
                    !isInThePast(event.reg_close_date, event.full_name) ?
                    <div className="text-center">
                      {authCtx.isLoggedIn ? (
                      <a href={`https://msmta.org/registration/regMain.php?event_id=${event.event_id}`} target="_blank" rel="noreferrer">
                        Register Here
                      </a>
                      ) : (<p>Please <Login handleLogin={authCtx.onLogin} variant="link"/> to register</p>)}
                    </div> 
                    :
                    <div className="text-center">
                      Registration for this event has been closed.{/* <br></br><br></br> */}
                      <MyRegistrations eventId={event.event_id} />
                    </div>
                    ) : 
                    <div className="text-center">
                      <p className="fw-bold">This event doesn't have online registration. Please open the <Link to="/dynamiccontent/studentpacket">Student Packet</Link> for submission information.</p>
                    </div>
                  }
                  </tr>
                  {event.eventLocation ? (
                    <tr>
                      <div className="text-center">
                        {event.locationLink ? ( 
                          <p>Location: <a href={event.locationLink} target="_blank">{event.eventLocation}</a></p>
                        ) : (
                          <p>Location: {event.eventLocation}</p>
                        )}
                      </div>
                    </tr>
                  ) : undefined }
                  <tr>
                    {event.infoFilename ? (
                      // event.isOnline ? <div className="text-center"><a href={`https://msmta.org/eventFiles/eventInfo/${event.infoFilename}`}  target="_blank" rel="noreferrer">Event Rules and Regulations</a></div> : 
                      // <div className="text-center"><a href={`https://msmta.org/eventFiles/eventInfo/${event.infoFilename}`}  target="_blank" rel="noreferrer">Application Form</a></div>
                      event.isOnline ? <div className="text-center"><a href={`https://msmta.org/eventFiles/eventInfo/mcmta/${event.infoFilename}`}  target="_blank" rel="noreferrer">Event Rules and Regulations</a></div> : 
                      <div className="text-center"><a href={`https://msmta.org/eventFiles/eventInfo/mcmta/${event.infoFilename}`}  target="_blank" rel="noreferrer">Application Form</a></div>
                    ) : undefined }
                  </tr>
                </tbody>
              </Table>
            </Accordion.Body>
            </Accordion.Item> //: undefined
          ))}
        </Accordion>
        </Row>
        </Container>
        </Wrapper>
    </Container>
  );
};

export default Events;
